import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Mofoluwasho from "../../../assets/shortlist_23/mofoluwasho.png";
import Arowolo from "../../../assets/shortlist_23/arowolo.png";
import Hellen from "../../../assets/shortlist_23/helen.png";
import Crystal from "../../../assets/shortlist_23/crystal.png";

const disabilityNominees = [
  {
    name: "Mofoluwasho Liasu",
    title: "Super Parents Foundation",
    imgpath: Mofoluwasho,
  },
  {
    name: "Arowolo Ayoola Abimbola",
    title: "Datalead Africa",
    imgpath: Arowolo,
  },
  {
    name: "Hellen Anurika Beyioku Alase",
    title: "Deaf Women Aloud Initiative (DWAI)",
    imgpath: Hellen,
  },
  {
    name: "Crystal Chigbu",
    title: "LEAP (Limb Empowerment and Advocacy Program)",
    imgpath: Crystal,
  },
];

const DisabilityNominees = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      marginTop={{ xs: "10%", sm: "3%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Disability Rights Advocacy / Empowerment Award (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {disabilityNominees.map((nominate, index) => {
          const { name, title, imgpath } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default DisabilityNominees;
